import { DataGrid, gridClasses, GridPaginationModel } from "@mui/x-data-grid";

type CustomDataGridProps = {
    filteredRows: any[];
    columns: any[];
    paginationModel?: any;
    setPaginationModel?: (value: any) => void;
    totalLength?: number;
    loading: boolean;
    autoRowHeight?: boolean;
}

export const CustomDataGrid = ({
    filteredRows,
    columns,
    paginationModel,
    setPaginationModel,
    totalLength,
    loading,
    autoRowHeight = false,
}: CustomDataGridProps) => {


    return (
        <div className={`w-full ${filteredRows?.length > 8 || paginationModel ? 'h-[340px]' : 'h-auto'}`}>
            <DataGrid
                rows={filteredRows}
                columns={columns}
                {...(autoRowHeight && { getRowHeight: () => 'auto' })}
                disableRowSelectionOnClick
                initialState={{
                    pagination: {
                        paginationModel: {
                            pageSize: 10,
                        },
                    },
                }}
                pageSizeOptions={[5, 10, 15, 20, 25, 50, 75, 100]}
                paginationModel={
                    paginationModel && {
                        page: paginationModel.page - 1,
                        pageSize: paginationModel.pageSize,
                    }
                }
                paginationMode="server"
                onPaginationModelChange={
                    (model: GridPaginationModel) => {
                        if (model?.pageSize !== paginationModel?.pageSize) {
                            setPaginationModel && setPaginationModel({
                                page: 1,
                                pageSize: model?.pageSize,
                            });
                            return;
                        }

                        setPaginationModel && setPaginationModel({
                            page: model?.page + 1,
                            pageSize: model?.pageSize,
                        });
                    }}
                rowCount={totalLength || 0}
                disableColumnMenu
                loading={loading}
                slotProps={{
                    loadingOverlay: {
                        variant: 'skeleton',
                        noRowsVariant: 'skeleton',
                    },
                }}
                hideFooter={paginationModel ? false : true}
                showCellVerticalBorder={true}
                sx={{
                    borderTop: "1px solid #E4E7EC",
                    border: "none",
                    fontSize: "12px",
                    wordWrap: "break-word",
                    overflow: "visible",
                    color: "#1D2939",
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-actions button, & .MuiTablePagination-displayedRows, & .MuiTablePagination-root': {
                        color: "rgba(0, 0, 0, 0.54)",
                    },
                    '& .MuiDataGrid-columnHeaders': {
                        border: "none",
                        color: "rgba(0, 0, 0, 0.54)",
                        fontWeight: 700
                    },
                    [`& .${gridClasses.cell}`]: {
                        py: 1,

                    },
                }}
            />
        </div>
    )
}